module.exports = __webpack_public_path__ + "static/media/pCWS-BNB.bb00536f.svg";